// extracted by mini-css-extract-plugin
export var container = "_32-0";
export var icon = "_32-1";